
import { Component, Vue } from "vue-property-decorator";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import FaqSection from "@/components/FaqSection.vue";

@Component({
  components: { Breadcrumb, FaqSection }
})
export default class FenChaiDui extends Vue {
  breadcrumbList = [
    { name: "首页", url: "/" },
    { name: "知识中心" },
    { name: "分拆对™工作法" }
  ];

  faqList = [
    { question: "分拆对™工作法是什么？", answer: "分拆对™工作法是光华赋能独创的企业经营落地工具，通过「分（分层分类）、拆（拆解动作）、对（对齐复盘）」三个核心步骤，将企业战略目标层层分解到每个人，确保战略落地执行。" },
    { question: "分拆对™工作法适合什么企业？", answer: "适合所有希望提升战略执行能力和绩效管理水平的企业，尤其适合遇到战略执行难题、目标与工作脱节、部门协同不畅的成长型企业。" },
    { question: "分拆对™与BLM方法论是什么关系？", answer: "BLM方法论解决「做什么」的战略制定问题，分拆对™工作法解决「怎么做」的战略执行问题，二者共同构成科学经营™的两大支柱。" },
    { question: "如何学习和应用分拆对™工作法？", answer: "可通过光华大增长营、科研院等课程系统学习，通过咨询陪跑服务在企业实践中落地，也可通过光华EPM企业绩效系统实现数字化应用。" }
  ];
}
